(function () {
    'use strict';

    angular
        .module('platformRental')
        .config(PlatformRentalRoute);

        PlatformRentalRoute.$inject = ['$stateProvider'];

    /* @ngInject */
    function PlatformRentalRoute ($stateProvider) {
        $stateProvider
            .state('root.platformRental', {
                abstract: true,
                url: '/platform-rental',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                },
            })
            .state ('root.platformRental.dashboard', {
                url: '/dashboard',
                views: {
                    "inner-view@root": {
                      templateUrl: "templates/virtualfairs/report/total-student/list.html",
                      controller: "virtualFairsTotalStudentController",
                      controllerAs: "virtualFairTotalStudent",
                    },
                },
                resolve: {
                    virtualfairs: function (PlatformRentalService, toastr) {
                        return PlatformRentalService.getVirtualFairs(true)
                          .then((response) => {
                            return response.data;
                          }).catch((err) => {
                              console.log(err);
                            toastr.error("Something went wrong. Please try again later");
                          });
                    },
                    isPlatformRental: () => true,
                }
            })
            .state('root.platformRental.exhibitors', {
                abstract: true,
                url: '/exhibitors',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                },
            })
            .state ('root.platformRental.registrations', {
                url: '/registrations',
                views: {
                    "inner-view@root": {
                      templateUrl: "templates/platform-rental/registration-data/reportFilter.html",
                      controller: "PlatformRentalRegistrationsController",
                      controllerAs: "platformRentalRegistrations",
                    },
                },
                resolve: {
                    virtualfairs: function (PlatformRentalService, toastr) {
                        return PlatformRentalService.getVirtualFairs(true)
                          .then((response) => {
                            return response.data;
                          }).catch((err) => {
                              console.log(err);
                            toastr.error("Something went wrong. Please try again later");
                          });
                    },
                    isPlatformRental: () => true,
                }
            })
            .state ('root.platformRental.networkingEvent', {
                url: "/networking-event",
                views: {
                "inner-view@root": {
                    templateUrl: "templates/virtualfairs/networking-event/list.html",
                    controller: "VirtualFairNetworkingEventController",
                    controllerAs: "virtualNetworkingEvent",
                },
                },
                resolve: {
                    networkingEventUsersTypes,
                    virtualFairs: function (PlatformRentalService, toastr) {
                        return PlatformRentalService.getVirtualFairs(true)
                          .then((response) => {
                            return response.data;
                          }).catch((err) => {
                              console.log(err);
                            toastr.error("Something went wrong. Please try again later");
                          });
                    },
                    isPlatformRental: () => true,
                },
            })
            .state ('root.platformRental.representatives', {
                url: "/representatives",
                views: {
                    "inner-view@root": {
                        templateUrl:
                            "templates/virtualfairs/report/exhibitor/representatives/list.html",
                            controller: "VirtualFairExhibitorRepresentativeController",
                            controllerAs: "virtualFairExhibitorRepresentative",
                    }
                },
                resolve: {
                    virtualFairs: function (PlatformRentalService, toastr) {
                        return PlatformRentalService.getVirtualFairs(true)
                          .then((response) => {
                            return response.data;
                          }).catch((err) => {
                              console.log(err);
                               toastr.error("Something went wrong. Please try again later");
                          });
                    },
                    isPlatformRental: () => true,
                },
            })
            .state("root.platformRental.generalReport", {
                url: "/general-report",
                views: {
                  "inner-view@root": {
                    templateUrl:
                      "templates/virtualfairs/report/post-event/general-information/reportFilter.html",
                    controller: "VirtualFairGeneralInformationController",
                    controllerAs: "virtualFairGeneralInformation",
                  },
                },
                resolve: {
                    virtualFairs: function (PlatformRentalService, toastr) {
                      let query = {};
                      query['past'] = 1;
                        return PlatformRentalService.getVirtualFairs(true, query)
                          .then((response) => {
                            return response.data;
                          }).catch((err) => {
                              console.log(err);
                               toastr.error("Something went wrong. Please try again later");
                          });
                    },
                    isPlatformRental: () => true,
                },
            })
            .state("root.platformRental.visitorsBooth", {
                url: "/visitors-per-booth",
                views: {
                  "inner-view@root": {
                    templateUrl:
                      "templates/virtualfairs/report/post-event/leads-booth/reportFilter.html",
                    controller: "VirtualFairLeadsBoothController",
                    controllerAs: "virtualFairLeadsBooth",
                  },
                },
                resolve: {
                    virtualFairs: function (PlatformRentalService, toastr) {
                        let query = {};
                        query['past'] = 1;
                        return PlatformRentalService.getVirtualFairs(true, query)
                          .then((response) => {
                            return response.data;
                          }).catch((err) => {
                              console.log(err);
                               toastr.error("Something went wrong. Please try again later");
                          });
                    },
                    isPlatformRental: () => true,
                }
            })
            .state("root.platformRental.postNetworking", {
                url: "/post-networking",
                resolve: {
                    virtualFairs: function (PlatformRentalService, toastr) {
                      let query = {};
                      query['past'] = 1;
                        return PlatformRentalService.getPostNetworkingEvents(true, query)
                          .then((response) => {
                            return response.data;
                          }).catch((err) => {
                              console.log(err);
                               toastr.error("Something went wrong. Please try again later");
                          });
                    },
                    isPlatformRental: () => true,
                },
                views: {
                  "inner-view@root": {
                    templateUrl: "templates/virtualfairs/report/post-networking/reportFilter.html",
                    controller: "VirtualFairPostNetworkingController",
                    controllerAs: "virtualFairPostNetworking",
                  },
                },
            })
            .state("root.platformRental.generalStatistics", {
              url: "/general-statistics",
              resolve: {
                    virtualFairs: function (PlatformRentalService, toastr) {
                        let query = {};
                        query['past'] = 1;
                        return PlatformRentalService.getVirtualFairs(true, query)
                          .then((response) => {
                            return response.data;
                          }).catch((err) => {
                              console.log(err);
                              toastr.error("Something went wrong. Please try again later");
                          });
                    },
                    physicalFairs: function (PlatformRentalService, toastr) {
                        let query = {};
                        query['past'] = 1;
                        return PlatformRentalService.getPhysicalFairs(true, query)
                          .then((response) => {
                            return response.data;
                          }).catch((err) => {
                              console.log(err);
                              toastr.error("Something went wrong. Please try again later");
                          });
                    },
                    isPlatformRental: () => true,
              },
              views: {
                "inner-view@root": {
                  templateUrl: "templates/platform-rental/general-statistics/list.html",
                  controller: "PlatformRentalGeneralStatisticsController",
                  controllerAs: "platformRentalGeneralStatistics",
                },
              },
          })
          .state ('root.platformRental.physicalVisitors', {
              url: '/physicalVisitors',
              views: {
                  "inner-view@root": {
                    templateUrl: 'templates/physicalfairs/reports/total-student/list.html',
                    controller: 'PhysicalFairTotalStudentsController',
                    controllerAs: 'physicalFairTotalStudents'
                  },
              },
              resolve: {                    
                  isPlatformRental: () => true,
              }
          })
          .state("root.platformRental.leadsBooth", {
            url: "/leads-per-booth",
            views: {
              "inner-view@root": {
                templateUrl:
                  "templates/physicalfairs/reports/post-event/leads-booth/reportFilter.html",
                controller: "PhysicalFairLeadsBoothController",
                controllerAs: "physicalFairLeadsBooth",
              },
            },
            resolve: {
              physicalFairs: function (PlatformRentalService, toastr) {
                let query = {};
                query['past'] = 1;
                return PlatformRentalService.getPhysicalFairs(true, query)
                  .then((response) => {
                    return response.data;
                  }).catch((err) => {
                      console.log(err);
                      toastr.error("Something went wrong. Please try again later");
                  });
              },
              isPrivate: () => false,
              isPlatformRental: () => true,
            }
        })
            
    }
    function networkingEventUsersTypes() {
        return [
          { name: "Exhibitor", id: "exhibitor" },
          { name: "Partner", id: "partner" },
        ];
    }
})();